import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://api.tbh.social/admin",
    headers: {
        "Content-Type": "application/json",
    },
});

// Request interceptor — attach auth token if present
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor — centralize error handling
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const { status } = error.response;

            if (status === 401) {
                // token expired / invalid — clear and redirect to login
                localStorage.removeItem("token");
                window.location.href = "/login";
            }
        } else if (error.request) {
            console.error("No response received from server:", error.request);
        } else {
            console.error("Axios setup error:", error.message);
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;